import React from 'react';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../context/useAppContext';
import { Dropdown, ToastContext } from '@weezevent/nacre';
import RateTemplate from '../../../../models/rateTemplate';
import PropTypes from 'prop-types';

export function GenerateTemplateFromRateAction({ objects: selectedRates, onSave }) {
    const { t } = useTranslation();
    const [{ event, organization }] = useAppContext();
    const toast = React.useContext(ToastContext);

    const transformRate = React.useCallback(
        rate => {
            let rate_template = new RateTemplate({
                source_rate_id: rate.pk
            });
            rate_template
                .save({ organizationId: organization.pk })
                .then(() => {
                    toast.success(t(`ticket.rates.transformSuccess`));
                    onSave();
                })
                .catch(e => {
                    console.error(e);
                    toast.error(t(`ticket.rates.transformError`));
                });
        },
        [event, organization, onSave]
    );

    if (selectedRates.length !== 1) {
        return null;
    }

    return <Dropdown.Item onClick={() => transformRate(selectedRates[0])}>{t('ticket.rates.transform')}</Dropdown.Item>;
}

GenerateTemplateFromRateAction.propTypes = {
    objects: PropTypes.array, //required
    onSave: PropTypes.func.isRequired
};
